import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  RouterProvider,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import FormStep from "../../../components/Forms/FormCreateTemplate/FormStep";
import {
  PopulatedTemplate,
  TemplatePayload,
} from "../../../models/SurveyModels";
import { useEndpoints } from "../../../hooks/useEndpoints";
import { useToastAlert } from "../../../components/ToastAlert/ToastAlert";
import { DURATION_TOAST } from "../../../utils/costants";
import { IErrorsCompanies } from "../../../models/CompaniesModel";
import { RoutesRouter } from "../../../models/Routes";
import { compareObject } from "../../../utils/functions";

export const CreateTemplate: FC = (props) => {
  const { t } = useTranslation();
  const [template, setTemplate] = useState<PopulatedTemplate>();
  const { getTemplatebyId, putTemplate, createTemplate } = useEndpoints();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToastAlert();
  const [status, setStatus] = useState<0 | 200 | 400 | 500 | 201>(0);
  const navigate = useNavigate();
  const { id } = useParams();
  const onSubmit = async (data: TemplatePayload) => {
    if (id) {
      const {
        createdAt,
        id: idTemplate,
        status,
        ...compareTemplate
      } = template || {};
      
      data.questions = data.questions.map(({ column, ...rest }) => rest);
      const isEqual = compareObject(compareTemplate, data);
      if (isEqual) setStatus(200);
      else {
        const response = await putTemplate(id, data);
        if (response.status === 200) {
          setStatus(200);
          showToast({
            message: `${t("home.template.toast.success.edit")}`,
            type: "success",
            duration: DURATION_TOAST,
          });
        }
        if (response.status === 400) {
          setStatus(400);
          const { errors } = await response.json();
          errors.map(({ value, msg, param }: IErrorsCompanies) =>
            showToast({
              message: `${msg} ${param}`,
              subMessage: value,
              type: "error",
            })
          );
        }
        if (response.status === 500) {
          setStatus(500);
          showToast({
            message: `${t("home.template.toast.error.generic")}`,
            type: "error",
          });
        }
      }
    }
  };
  const onSubmitCreate = async (data: TemplatePayload) => {
    const response = await createTemplate(data);
    if (response.status === 201) {
      navigate(RoutesRouter.template);
      showToast({
        message: `${t("home.template.toast.success.create")}`,
        type: "success",
        duration: DURATION_TOAST,
      });
    }
    if (response.status === 400) {
      setStatus(400);
      const { errors } = await response.json();
      errors?.map(({ value, msg, param }: IErrorsCompanies) =>
        showToast({
          message: `${msg} ${param}`,
          subMessage: value,
          type: "error",
        })
      );
    }
    if (response.status === 500) {
      showToast({
        message: `${t("home.template.toast.error.generic")}`,
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (state) {
      setIsLoading(true);
      const { duplicationContent } = state;
      setTemplate(duplicationContent);
      setIsLoading(false);
    } else {
      if (id !== undefined) {
        setIsLoading(true);
        getTemplatebyId(id).then((resp) => {
          setTemplate(resp);
          setIsLoading(false);
        });
      }
    }
  }, [getTemplatebyId, id, state]);
  return (
    <FormStep
      isLoading={isLoading}
      id={id}
      status={status}
      onSumbitForm={onSubmit}
      onSubmitCreate={onSubmitCreate}
      templateData={template}
    />
  );
};
